import type { ProjectQuoteFieldsState } from "components/QuoteFields";

/*
The shared project quote field state plus the off-platform carrier's identity. A
single shipment simply leaves the loads fields null, so one state shape serves
both shipment types.
*/
export interface OffPlatformBookingFormState extends ProjectQuoteFieldsState {
  carrierEmail: string;
  carrierCompanyName: string;
}

export const INITIAL_OFF_PLATFORM_BOOKING_STATE: OffPlatformBookingFormState = {
  equipmentType: "",
  pickupStart: "",
  pickupStartTime: "",
  deliveryEta: "",
  deliveryEtaTime: "",
  currency: "CAD",
  price: null,
  notes: "",
  trackingLinkOffered: false,
  minimumLoads: null,
  maxLoads: null,
  carrierEmail: "",
  carrierCompanyName: "",
};

// Which entry point opened the modal, so analytics can tell them apart.
export type OffPlatformBookingSource = "sidebar_menu" | "cancellation_modal";
